// extracted by mini-css-extract-plugin
export var editInput = "_fa-0";
export var editInputCompact = "_fa-2";
export var editInputLarge = "_fa-1";
export var editInputSmall = "_fa-3";